import React, { Component } from 'react';
import { withRouter } from 'react-router'
import Constants from './Constants.js';
import $ from 'jquery';
// import moment from 'moment';

class CreateDemoAccount extends Component {

  constructor(props) {
    super(props);
    this.state = {
      'submitted': false,
      'name': '',
      'processing': false
    }
  } 
  
  componentWillMount() {

  }

  updateName(e) {
    this.setState({
      'name': e.target.value
    })
  }

  submit(e) {
    e.preventDefault()

    const self = this;

    this.setState({
      'processing': true
    })

    var data = {
      'name': this.state.name
    }

    $.ajax({
      type: 'POST',
      url: `${Constants.API_HOST}organizations/demo_account/`,
      contentType: 'application/json',
      data: JSON.stringify(data),
      dataType: 'json',
      xhrFields: { withCredentials:true },
      timeout: 0,
      success: function success(data) {
        self.setState({
          'submitted': true,
          'processing': false
        })

      },
      error: function error(data) {
        alert('There was an error creating the demo account.');
      }
    });
  }

  render() {

    if (this.state.processing) {
      return (
        <div className="loader">Loading...</div>
      )      
    }

    if (this.state.submitted) {
      return (
        <div>
          Your request has been submitted.
        </div>
      )
    }

    return (
      <div>

        <h1>Create Demo Account</h1>

        <p>Use this form to create a demo account. You will recieve an e-mail after the account
        has been setup with the credentials to login. Accounts can take up to 15 minutes to setup.</p>

        <form onSubmit={this.submit.bind(this)}>
          <div className="form-group">

            <label htmlFor="orgname">Demo Organization Name</label>
            <input value={this.state.name} onChange={e => this.updateName(e)} type="text" name="name" className="form-control" id="orgname" />
          </div>

          <input className="btn btn-primary" type="submit" value="Create Demo Account" />
        </form>
      </div>
    );
  }
}

export default withRouter(CreateDemoAccount);


// WEBPACK FOOTER //
// ./src/components/CreateDemoAccount.js